import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "c-cu-child-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "list__item--header" }
const _hoisted_4 = { class: "list__item--body" }
const _hoisted_5 = { class: "account" }
const _hoisted_6 = { class: "stats" }
const _hoisted_7 = { class: "all" }
const _hoisted_8 = { class: "error" }

import {ITableItem} from "@/types/table";
import {computed, nextTick, onBeforeUnmount, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import router from "@/router";

interface IChildList {
  list: ITableItem[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomChildList',
  props: {
    list: {}
  },
  emits: ["scroll"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit

const listRef = ref<HTMLElement | null>(null);
const itemRefs = ref<HTMLElement[]>([]);
const hasScrolledToActive = ref(false);

const route = useRoute();
const activeItemId = computed(() => route.params.id);

const setItemRef = (el: Element | null, index: number) => {
  if (el) {
    itemRefs.value[index] = el as HTMLElement;
  }
};

const scrollActiveToTop = async () => {
  if (hasScrolledToActive.value) return;

  await nextTick();

  const container = listRef.value;
  const activeIndex = props.list.findIndex(
      item => String(item.chat_id) === String(activeItemId.value)
  );

  if (activeIndex === -1) return;

  const activeEl = itemRefs.value[activeIndex];
  if (!container || !activeEl) return;

  container.scrollTo({
    top: activeEl.offsetTop,
    behavior: "smooth",
  });

  hasScrolledToActive.value = true;
};

const selectNewItem = (item: any) => {
  router.push({path: `/chat/${item.chat_id}`, query: {chat: item.account_id}});
};

const handleScroll = () => {
  const el = listRef.value
  if (!el) return

  const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight

  if (distanceFromBottom < 200) {
    emit("scroll", 'bottom');
  }

  if (el.scrollTop < 200) {
    emit("scroll", 'top');
  }
}

onMounted(async () => {
  if (listRef.value) {
    listRef.value.addEventListener('scroll', handleScroll)
  }
})

onBeforeUnmount(() => {
  if (listRef.value) {
    listRef.value.removeEventListener('scroll', handleScroll)
  }
})

watch(
    activeItemId,
    () => {
      hasScrolledToActive.value = false;
      scrollActiveToTop();
    },
    {immediate: true}
);

watch(
    () => props.list,
    () => {
      itemRefs.value = [];
      scrollActiveToTop();
    },
    {deep: true}
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "list",
      ref_key: "listRef",
      ref: listRef
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          ref_for: true,
          ref: el => setItemRef(el, index),
          class: _normalizeClass(["list__item", { active: String(item.chat_id) === String(activeItemId.value) }]),
          onClick: ($event: any) => (selectNewItem(item))
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.session_name), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString(item.messages.total), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(item.errors.total), 1)
              ])
            ])
          ])
        ], 10, _hoisted_2))
      }), 128))
    ], 512)
  ]))
}
}

})